import styled, { css, DefaultTheme } from 'styled-components'

type TButtonProps = {
  $isDisabled?: boolean
  $isLoading?: boolean
  $secondary?: boolean
}

export const ButtonContainer = styled.button<TButtonProps>`
  max-height: 48px;
  min-height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: ${({ $isLoading, $isDisabled }) =>
    $isLoading || $isDisabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ $isLoading, $isDisabled }) =>
    $isLoading || $isDisabled ? 0.7 : 1};
  width: 100%;
  transition: background-color 0.2s;

  ${({ theme, $secondary }) => css`
    background-color: ${$secondary
      ? theme.colors.buttonSecondaryColor
      : theme.colors.buttonPrimaryColor};
  `}

  &:hover {
    ${({ theme, $secondary }) => css`
      background-color: ${$secondary
        ? theme.colors.buttonPressedSecondaryColor
        : theme.colors.buttonPressedPrimaryColor};
    `}
  }
`

export const ButtonText = styled.span`
  color: white;
  font-size: 16px;
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

const fontColor = (theme: DefaultTheme, secondary?: boolean) =>
  secondary ? theme.colors.buttonSecondaryText : theme.colors.buttonPrimaryText

export const Title = styled.span<TButtonProps>`
  font-size: 16px;
  padding-left: 10px;

  ${({ theme, $secondary }) => css`
    color: ${fontColor(theme, $secondary)};
    font-family: ${theme.fonts.text};
    font-weight: ${theme.fonts.textWeight};
  `}
`

export const Spinner = styled.div<TButtonProps>`
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top-color: ${({ theme, $secondary }) => fontColor(theme, $secondary)};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`
